import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Box, Typography, Button } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddIcon from "@mui/icons-material/Add";
import Loading from "../../../../../components/loading/loading";
import "./coverage-area.css";
import { getCoverageAreasRequest } from "../../../../../redux/inspection-firms/slice";
import CoverageTable from "./CoverageTable";
import EditCoverageArea from "./edit-coverage-area/edit-coverage-area";

type props = {
  data: any;
};

const CoverageArea = ({ data }: props) => {
  const dispatch = useDispatch();
  const [showEditCoverageArea, setShowEditCoverageArea] = useState(false);
  const [selectedCoverageArea, setSelectedCoverageArea] = useState(null);
  const [addCoverageAreaCase, setAddCoverageAreaCase] = useState(false);

  useEffect(() => {
    dispatch(getCoverageAreasRequest({ id: data?.id }));
  }, [data, dispatch]);

  const { loading, coverageAreas } = useSelector(
    (state: any) => state.inspectionFirms
  );

  const handleEditCoverageArea = (area: React.SetStateAction<null>) => {
    setSelectedCoverageArea(area);
    setShowEditCoverageArea(true);
  };

  return (
    <>
      <Box
        sx={{ mt: 3 }}
        className="clients-header"
        justifyContent={"flex-end"}
      >
        <Button
          className="primary-bg"
          id="add-button"
          variant="contained"
          disableElevation
          onClick={() => {
            setAddCoverageAreaCase(true);
            setShowEditCoverageArea(true);
          }}
          startIcon={<AddIcon />}
        >
          Add Coverage Area
        </Button>
      </Box>
      {coverageAreas?.length > 0 &&
        coverageAreas.map((area: any) => (
          <Card className="card-layout">
            <Box className="card-header">
              <Typography variant="h5">{area?.displayName}</Typography>
              <Button
                variant="text"
                startIcon={<EditOutlinedIcon />}
                onClick={() => handleEditCoverageArea(area)}
              >
                Edit
              </Button>
            </Box>
            <Box className="user-name-layout">
              <Typography className="label-txt">Coverage Area</Typography>
              <CoverageTable area={area} />
            </Box>
          </Card>
        ))}

      {loading && <Loading />}
      {showEditCoverageArea && (
        <EditCoverageArea
          showDialog={showEditCoverageArea}
          closeDialog={() => {
            setAddCoverageAreaCase(false);
            setShowEditCoverageArea(false);
            setSelectedCoverageArea(null);
          }}
          data={{ ...(selectedCoverageArea || {}), inspectionFirmId: data?.id }}
          addCoverageAreaCase={addCoverageAreaCase}
        />
      )}
    </>
  );
};

export default CoverageArea;
